import $ from "jquery";

if (document.querySelector(".mini-slider")) {

    const miniSliders = document.querySelectorAll(".mini-slider__slider");

    miniSliders.forEach(slider => {
        console.log(slider.dataset.slides);
        const slidesToShow = Number(slider.dataset.slides);
        $(slider).slick({
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToShow,
            appendArrows: $(slider.closest(".mini-slider").querySelector(".slider-controls__arrows")),
            prevArrow: "<button type='button' class='slick-prev d-none d-md-block'><i class='fal fa-chevron-left'></i></button>",
            nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
            dots: true,
            appendDots: $(slider.closest(".mini-slider").querySelector(".slider-controls__dots"))
        });
    });
}